// @flow
import { Box } from '@mui/material';
import useI18n from '@shared/helper/hooks/useI18n';

function Status({ value }: { value: bool }): React$Node {
	const { translate } = useI18n('finoShared');

	return (
		<Box color={value ? 'success.main' : 'error.main'}>
			{value ? translate('successful') : translate('unSuccessful')}
		</Box>
	);
}

export default Status;
